import { OverlayScrollbars } from 'overlayscrollbars';

/**
 * Scrollable node for an Ant Design table body — OverlayScrollbars viewport when attached,
 * otherwise the body itself (native scroll).
 */
export function getAntTableScrollElement(body: HTMLElement | null | undefined): HTMLElement | null {
  if (!body) return null;
  const instance = OverlayScrollbars(body);
  if (instance && OverlayScrollbars.valid(instance)) {
    return instance.elements().viewport;
  }
  return body;
}
